import styled from 'styled-components'
import {
	BLUE,
	WHITE,
	MEDIUMORANGE,
	LIGHTGRAY,
	GREEN,
	STRONGORANGE,
	RED
} from '../../../../../styles/colors.style'
import { breakpoints } from '../../../../../constants'

export const Container = styled.section`
	margin-top: -24px;
	background: ${BLUE};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 10px;

	.msg-error {
		color: ${RED};
		text-align: center;
	}

	h2 {
		color: ${WHITE};
		font: 600 22px/28px 'Source Sans Pro';
		padding-bottom: 30px;
	}

	input[type='password'] {
		border: 0;
		background: transparent;
		color: ${WHITE};
		letter-spacing: 10px;
		font: 29px 'Source Sans Pro';
		max-width: 240px;
		height: 56px;
		font-size: 80px;
		outline: none;
		text-align: center;
		margin-bottom: 40px;

		&::-webkit-input-placeholder {
			/* Edge */
			color: ${WHITE};
			font: 40px/0 sans-serif;
		}

		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: ${WHITE};
			font: 40px sans-serif;
		}

		&::placeholder {
			color: ${WHITE};
			font: 40px sans-serif;
			font-weight: normal;
			font-style: normal;
		}
	}

	.footer {
		display: flex;
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 90%;
		max-width: 300px;
		flex: 1;
		min-height: 12vh;
		align-items: flex-end;

		@media (min-width: ${breakpoints.MOBILE}px) {
			width: 100%;
			max-width: 342px;
		}

		button {
			flex: 1;
			width: auto;
			height: 45px;
			background: ${MEDIUMORANGE};
			font: 600 22px/28px 'Source Sans Pro';
			border: 0;
			border-radius: 5px;
			color: ${WHITE};
			outline: none;
			cursor: pointer;

			&:first-child {
				margin-right: 20px;
			}

			&.transparent {
				background: transparent;
			}
		}
	}
`

export const Success = styled.div`
	position: absolute;
	top: 67%;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 99999;
	transform: translate(0, -50%);
	background: rgba(250, 250, 250, 0.9);
	display: flex;
	justify-content: center;

	@media (min-width: ${breakpoints.MOBILE}px) {
		top: 75%;
	}

	.box-success {
		height: 251px;
		transform: translate(0, -100%);
		top: 50%;
		position: absolute;

		@media (min-width: ${breakpoints.MOBILE}px) {
			transform: translate(0, -150%);
		}
	}

	p {
		font: 600 20px/25px 'Source Sans Pro';
		text-align: center;
		color: ${STRONGORANGE};
		margin-bottom: 30px;
	}

	.icon {
		font-size: 8em;
		margin: 0 auto 10px;
		display: flex;
		justify-content: center;
		color: ${LIGHTGRAY};

		&.animate {
			animation: fa-spin 3s infinite linear;
		}

		&.green {
			color: ${GREEN};
		}
	}

	.lk-mycard {
		margin: 0 auto;
		width: 262px;
		height: 45px;
		border-radius: 5px;
		background: ${MEDIUMORANGE};
		color: ${WHITE};
		font: 600 17px/45px 'Source Sans Pro';
		cursor: pointer;
		display: block;
		text-align: center;
	}
`
